import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

import { useNotifications } from "../../Services/NotificationsContext";
import { notificationCopy } from "../../utils/notifications";
import { formatInitials } from "../../utils/format";
import "./NotificationToasts.css";

/**
 * Popup-notiser högst upp på skärmen. Ligger utanför routern-innehållet så
 * att de följer med oavsett vilken sida man står på.
 */
export default function NotificationToasts() {
  const { toasts, dismissToast } = useNotifications();
  const navigate = useNavigate();

  if (!toasts.length) return null;

  return (
    <div className="notification-toasts" role="status" aria-live="polite">
      {toasts.map((notification) => {
        const copy = notificationCopy(notification);

        return (
          <div key={notification.id} className="notification-toast">
            <button
              type="button"
              className="notification-toast-body"
              onClick={() => {
                dismissToast(notification.id);
                navigate(copy.href);
              }}
            >
              <div className="notification-toast-media">
                {copy.imageUrl ? (
                  <img src={copy.imageUrl} alt="" />
                ) : (
                  <span>{formatInitials(copy.initialsFrom)}</span>
                )}
              </div>

              <div className="notification-toast-text">
                <strong>
                  <span className="notification-actor">{copy.actor}</span>{" "}
                  <span className="notification-action">{copy.action}</span>
                  {copy.subject && (
                    <>
                      {" "}
                      <span className="notification-subject">{copy.subject}</span>
                    </>
                  )}
                </strong>

                <small>{copy.meta}</small>
              </div>
            </button>

            <button
              type="button"
              className="notification-toast-close"
              aria-label="Dismiss notification"
              onClick={() => dismissToast(notification.id)}
            >
              <X size={14} strokeWidth={2.2} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
